import React, { useEffect } from "react";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer/Footer";
import { Routes, Route, Navigate, useParams, Outlet } from "react-router-dom";
import "./App.css";
import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import Activities from "./Pages/Activities";
import Sponsor from "./Pages/Sponsor";
import Register from "./Pages/Register";
import Conferance from "./Pages/Conferance";
import Conditions from "./Pages/Conditions";
import "react-toastify/dist/ReactToastify.css";
import ScrollToTop from "./Components/ScrollToTop";
import ScrollToAnchor from "./Components/ScrollToAnchor";
import VIPForm from "./Components/VIPForm";
import Agenda from "./Pages/Agenda";
import Speacker from "./Pages/Speaker";
import Speackers from "./Components/Speackers";
import SfmaHackathon from "./Pages/SfmaHackathon";
import CertificateForm from "./Components/CertificateForm";
import ConferanceAgenda from "./Pages/ConferanceAgenda";

const SUPPORTED_LANGS = ["ar", "en"];

/** Sync i18n with /:lang and reject unsupported langs */
const LangLayout = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (SUPPORTED_LANGS.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      localStorage.setItem("i18nLang", lang);
    }
  }, [lang, i18n]);

  if (!SUPPORTED_LANGS.includes(lang)) {
    return <Navigate to="/ar/home" replace />;
  }

  return <Outlet />;
};

const RedirectLegacyAbout = () => {
  const { lang } = useParams();
  return <Navigate to={`/${lang}/about`} replace />;
};

function App() {
  const { i18n } = useTranslation();
  const savedLang =
    localStorage.getItem("i18nLang") ||
    (i18n.language?.startsWith("en") ? "en" : "ar");
  const defaultRoute = savedLang === "en" ? "/en/home" : "/ar/home";

  return (
    <div className="App">
      <ScrollToTop />
      <ScrollToAnchor />
      <Navbar />
      <ToastContainer />
      <Routes>
        <Route path="/" element={<Navigate to={defaultRoute} replace />} />
        <Route path="/en" element={<Navigate to="/en/home" replace />} />
        <Route path="/ar" element={<Navigate to="/ar/home" replace />} />

        <Route path="/:lang" element={<LangLayout />}>
          <Route path="home" element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="About" element={<RedirectLegacyAbout />} />
          <Route path="SfmaHackathon" element={<SfmaHackathon />} />
          <Route path="activities" element={<Activities />} />
          <Route path="sponsores" element={<Sponsor />} />
          <Route path="agenda" element={<Agenda />} />
          <Route path="speacker/:id" element={<Speacker />} />
          <Route path="speackers" element={<Speackers />} />
          <Route path="register" element={<Register />} />
          <Route path="conferance" element={<Conferance />} />
          <Route path="conditions" element={<Conditions />} />
          <Route path="vip" element={<VIPForm />} />
          <Route path="certificate" element={<CertificateForm />} />
          <Route path="conferance_agenda" element={<ConferanceAgenda />} />
        </Route>

        <Route path="*" element={<Navigate to={defaultRoute} replace />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
